import type { Product } from '@/domain/types';
import type { DraftLine } from './DirectReceiveModal';

/** Build a Direct Import draft line from a picked catalogue product (manual entry). The snapshot_id
 *  guarantees resolution; pack size pre-fills units-per-pack. Batch/expiry/bin are entered next. */
export function newManualDraft(p: Product): DraftLine {
  return {
    id: crypto.randomUUID(),
    sku: p.snapshotKey || p.sku,
    product_name: p.name,
    product_snapshot_id: p.id,
    gtin: p.barcode || '',
    batch_number: '',
    expiry_date: '',
    qty_packs: 1,
    units_per_pack: parseInt(p.pack || '', 10) || 0,
    bin_allocations: [],
    controlled: p.cd,
    is_fridge: p.fridge,
    scanned_at: new Date().toISOString(),
    status: 'draft',
  };
}
